import {Attribute, Directive, inject, Injector, Optional} from '@angular/core';

import {
  DISPLAY_TYPE,
  IWidgetConfig,
  StylableComponent,
  provideAsWidgetRef,
  Parent,
  register,
  styler,
} from '@wm/components-base';
import { isArray, isEmpty, isObject, isString, forEach } from 'lodash-es';
import { getOrderedDataset } from '../../formWidgetUtils';
import $ from 'jquery';
import { getCanvasElement, ScriptLoaderService } from '@wm/core';

const defaultTreeIconClass: string = 'plus-minus';

const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-tree',
  hostClass: 'app-tree',
};

@Directive({
  selector: 'ul[wmTree]',
  providers: [provideAsWidgetRef(TreeDirective)],
  standalone: true,
  exportAs: 'wmTree',
})
export class TreeDirective extends StylableComponent {
  static initializeProps = register('wm-tree');

  // TODO: change the _selectNode type to HTMLElement
  private nodes: Array<any>;
  private orderby: string;
  private nodelabel: string;
  private treeicon: string;
  private name: string;
  private treeClass: string;
  private nodeicon: string
  scriptLoaderService=  inject(ScriptLoaderService);

  private setting: any = {
    data: {
      simpleData: {
        enable: true,
      },
    },
    view: {
      dblClickExpand: false,
      fontCss: {
        'font-awesome': true,
      },
      switchIcon: {},
    },
    check: {},
    callback: {},
  };
  private dataset: any;

  constructor(
    inj: Injector,
    @Optional() viewParent: Parent,
    @Attribute('datavalue.bind') private binddatavalue: any,
    @Attribute('nodelabel.bind') private bindnodelabel: any,
    @Attribute('nodeicon.bind') private bindnodeicon: any,
    @Attribute('nodechildren.bind') private bindnodechildren: any,
    @Attribute('nodeid.bind') private bindnodeid: any
  ) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }

  protected override onPropertyChange(key: string, nv: any, ov?: any) {
    switch (key) {
      case 'dataset':
        nv = nv || '' //sanity check
        // for now showing the default nodes
        const defaultNodes = 'node1, node2, node3';
        this.nodes = !nv.length ? this.getNodes(defaultNodes) : this.getNodes(nv);
        this.renderTree();
        break;
      case 'treeicons':
        this.treeicon = nv;
        this.changeTreeIcons(nv);
        break;
      case 'nodelabel':
        this.nodelabel = nv;
        break;
      case 'icon':
        this.nodeicon = nv;
        break;
      case 'orderby':
        this.renderTree();
        break;
      case 'class':
        this.treeClass = nv;
        break;
      default:
        super.onPropertyChange(key, nv, ov);
    }
  }

  // sets the template for the tree based on the property selected.
  setTreeTemplate(value: any) {
    if (value === 'Classic') {
      this.setting.check['enable'] = false;
    } else if (value === 'Checkbox') {
      this.setting.check['enable'] = true;
      this.setting.check['chkStyle'] = 'checkbox';
    } else if (value === 'Radio') {
      this.setting.check['enable'] = true;
      this.setting.check['chkStyle'] = 'radio';
      this.setting.check['radioType'] = 'all';
    }
  }

  getNodes(newVal: any) {
    let nodes;
    if (isArray(newVal)) {
      nodes = getOrderedDataset(newVal, this.orderby);
    } else if (isObject(newVal)) {
      nodes = [newVal];
    } else if (isString(newVal) && !isEmpty(newVal)) {
      newVal = newVal.trim();
      if (newVal) {
        nodes = this.getNodesFromString(newVal);
      }
    }
    return nodes;
  }

  getNodesFromString(value: any) {
    return value.split(',').map((item: any) => {
      return {
        label: item && item.trim(),
      };
    });
  }

  // adds class to the nodes inorder to add icons to respective node.
  setNodeclasses(treeId: any, treeNode: any) {
    return treeNode.icon ? { add: [`${treeNode.icon}`] } : '';
  }
  // Sets the node label with any icon if bound to
  setNodeLabel(nodes: any) {
    nodes.map((node: any) => {
      if (node.children) {
        this.setNodeLabel(node.children);
      }
      if (node.icon && this.nodelabel == 'icon') {
        node.name = node.icon;
      } else {
        return;
      }
    });
  }

  // Sets the node label with any icon if bound to
  private setNodeData(nodes: Array<any>, depth: number, level: number, parentNode: any, type: string) {
    if (depth === 0) {
      nodes.map((node) => {
        if (node.children) {
          this.setNodeData(node.children, depth, level, parentNode, type);
        }
        if (node.icon && this.nodelabel == 'icon') {
          node[type] = node.icon;
        } else if (node.name && this.nodelabel == 'name') {
          node[type] = node.name;
        } else {
          return;
        }
      });
    } else {
      nodes.map((node) => {
        if (node.children && level > 1) {
          if (depth === level) {
            parentNode = node;
          }
          this.setNodeData(node.children, depth, level - 1, parentNode, type);
        }
        if (level === 1 && (type === 'name' ? this.nodelabel.includes('label') || this.nodelabel.includes('name') : this.nodeicon.includes('label') || this.nodeicon.includes('name'))) {
          parentNode[type] = node.name || node.label;
          return;
        } else if (level === 1 && node.icon !== undefined && (type === 'name' ? this.nodelabel.includes('icon') : this.nodeicon.includes('icon'))) {
          parentNode[type] = node.icon;
          return;
        } else {
          return;
        }
      });
    }
  }

  changeTreeIcons(nv: any) {
    let canvasEl = getCanvasElement();
    let treeContainer = $(canvasEl).find('ul[name="' + this.name + '"]');
    let eleClose = $(treeContainer).find('li span.button.switch');
    $(eleClose).map((idx: any, ele: any) => {
      $(ele).addClass(nv);
    });
  }

  countDepth(str: string) {
    const regex = /\[.*?\]/g;
    let matches = str.match(regex);
    let count = 1;

    if(matches === null) return count;

    for (let match of matches) {
      count++;
    }

    return count;
  }

  // function to support backward compatibility of objects
  modifyObjects(array: any) {
    array.forEach((obj: any) => {
      if (obj.label !== undefined) {
        obj.name = obj.label;
        delete obj.label;
      }
      if (obj.children !== undefined) {
        this.modifyObjects(obj.children);
      }
    });
    return array;
  }

  async renderTree() {
    const z3Bundle: any = await this.scriptLoaderService.loadLazyScript('ztree-bundle');
    if(!z3Bundle.loaded) {
      console.error("Error loading calendar-bundle", z3Bundle.error);
      return;
    }
    if (this.nodes) {
      this.nativeElement.setAttribute('id', this.name);
      this.nodes = this.modifyObjects(this.nodes);
      this.setTreeTemplate(this.treeClass);

      if (this.nodelabel) {
        let depth = 0;
        if (this.nodelabel.includes('children')) {
          depth = this.countDepth(this.nodelabel);
        }
        this.setNodeData(this.nodes, depth, depth, null, 'name');
      }
      if (this.nodeicon) {
        let depth = 0;
        if (this.nodeicon.includes('children')) {
          depth = this.countDepth(this.nodeicon);
        }
        this.setNodeData(this.nodes, depth, depth, null, 'icon');
      }
    }
    if (this.nodelabel && this.nodes) {
      this.setNodeLabel(this.nodes);
    }
    this.setting.view['nodeClasses'] = this.setNodeclasses;

    let zTree = (window as { [key: string]: any })['$']().zTree;
    setTimeout(() => {
      let canvasEl = getCanvasElement();
      let treeContainer = $(canvasEl).find('ul[name="' + this.name + '"]');
      zTree.init($(treeContainer), this.setting, this.nodes);
    })
  }

  override ngAfterViewInit(): void {
    setTimeout(() => {
      this.changeTreeIcons(this.treeicon || defaultTreeIconClass);
    }, 200);
  }
}
